export class PlayerOreStats {
  constructor() {
    this.player_id = null;
    this.forfeited = null;
    this.mined = null;
    this.seized = null;
  }
}